import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

export const PurchaseOrdersPage = lazyWithRetry(() =>
  import('@erp/purchasing/pages/PurchaseOrdersPage.tsx'),
);

const purchaseOrdersNode = {
  component: PurchaseOrdersPage,
} satisfies ComponentPage;

const purchasingRoutes: ComponentOrMapping = {
  erp: {
    purchasing: {
      'purchase-orders': purchaseOrdersNode,
    },
  },
};

export default purchasingRoutes;
